import { useRouter } from 'next/router';

export default function useAppRouter() {
  const router = useRouter();
  return {
    ...router,
    pushHome() {
      router.push('/');
    },
    pushLogin(options?: {
      fromService?: string;
      redirectUrl?: string;
      mailAddr?: string;
      accountIntegrationCompleted?: boolean;
      reLogin?: string;
    }) {
      const p = new URLSearchParams();
      if (options?.fromService) {
        p.set('from_service', options.fromService);
      }
      if (options?.redirectUrl) {
        p.set('redirectUrl', options.redirectUrl);
      }
      if (options?.mailAddr) {
        p.set('mailAddr', options.mailAddr);
      }
      if (options?.accountIntegrationCompleted) {
        p.set(
          'account_integration_completed',
          options.accountIntegrationCompleted ? 'true' : 'false',
        );
      }
      if (options?.reLogin) {
        p.set('re_login', options.reLogin);
      }
      router.push(`/login?${p.toString()}`);
    },
  };
}
